import { crudService } from '../_services'
import { toast } from 'react-toastify'
import { stringUtils } from 'utils'

export const relatorioAction = {
  getRelatorioChecklist,
  getRelatorioChecklistOperacao,
  getRelatorioComprasComparativoPrecos,
  getRelatorioComprasVendas,
  getRelatorioCompras,
  getRelatorioContagemEstoque,
  getRelatorioContagemEstoqueArquivo,
  getRelatorioConversoes,
  getRelatorioLogs,
  getRelatorioNivelServico,
  getRelatorioPonto,
  getRelatorioPrecos,
  getRelatorioPrecosArquivo,
  getRelatorioDivergenciasFichaTecnica,
  getRelatorioRanking,
  getRelatorioRespostasChecklistsOperacoesImpressoes,
  getRelatorioTotvsInsumosUnidadesFornecedores,
  getRelatorioTroca,
  getRelatorioVendasInsumos,
  getRelatorioVendasProdutos,
  getRelatorioVendasInsumosArquivo,
  onChangeProps,
  clear,
  clearAll,
}

function getRelatorioChecklist(filterModel, showWaiting) {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'relatorios/checklist/' + stringUtils.serialize(filterModel);
    crudService
      .get(apiEndpoint)
      .then((response) => {
        dispatch(notIsLoading())
        dispatch(changeRelatorioList(response.data, null))
      })
      .catch((err) => {
        console.log(err);
        return err;
      })
  }
}

function getRelatorioChecklistOperacao(payload, showWaiting) {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'relatorios/checklistOperacao/'

    crudService
      .post(apiEndpoint, payload)
      .then((response) => {
        let relatorio = []

        if (response.data) {
          const checklistMap = response.data.checklistMap
          const checklistInsumoUnidadeMap = response.data.checklistInsumoUnidadeMap

          for (const key in checklistMap) {
            if (checklistMap.hasOwnProperty(key) && checklistInsumoUnidadeMap.hasOwnProperty(key)) {
              let checklistObj = {
                checklist: checklistMap[key],
                checklistsTotvsInsumosUnidades: checklistInsumoUnidadeMap[key]
              };

              relatorio.push(checklistObj)
            }
          }

          dispatch(notIsLoading())
          dispatch(changeRelatorioList(relatorio, null))
        }
      })
      .catch((err) => {
        console.log(err);
        return err;
      })
  }
}

function getRelatorioComprasComparativoPrecos(payload, showWaiting) {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'relatorios/compras/comparativoPrecos' + stringUtils.serialize(payload);
    crudService
      .get(apiEndpoint)
      .then((response) => {
        dispatch(notIsLoading())
        dispatch(changeRelatorioList(response.data, null))
      })
      .catch((err) => {
        console.log(err);
        return err;
      })
  }
}

function getRelatorioComprasVendas(payload, showWaiting) {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'relatorios/compras/vendas' + stringUtils.serialize(payload);
    crudService
      .get(apiEndpoint)
      .then((response) => {
        dispatch(notIsLoading())
        dispatch(changeRelatorioList(response.data, null))
      })
      .catch((err) => {
        console.log(err);
        return err;
      })
  }
}

function getRelatorioCompras(payload, showWaiting) {
  return (dispatch) => {
    dispatch(isLoading())

    let apiEndpoint = 'relatorios/compras'
    crudService
      .post(apiEndpoint, payload)
      .then((response) => {
        dispatch(changeRelatorioList(response.data, null))
      })
      .catch((err) => {
        console.log(err);
        return err;
      })
      .finally(() => {
        dispatch(notIsLoading())
      })
  }
}

function getRelatorioContagemEstoque(payload, showWaiting) {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'relatorios/contagemEstoque' + stringUtils.serialize(payload);
    crudService
      .get(apiEndpoint)
      .then((response) => {
        dispatch(changeRelatorioList(response.data, response.data.lista.totalRows))
      })
      .catch((err) => {
        console.log(err);
        return err;
      })
      .finally(() => {
        dispatch(notIsLoading())
      })
  }
}

function getRelatorioContagemEstoqueArquivo(filterModel, showWaiting) {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'relatorios/contagemEstoque/arquivo' + stringUtils.serialize(filterModel);
    crudService
      .get(apiEndpoint, { responseType: 'arraybuffer' })
      .then((response) => {
        var FileSaver = require('file-saver');
        var blob = new Blob([response.data], { type: 'text/csv;charset=utf-16le' });

        FileSaver.saveAs(blob, "relatorio_contagem_estoque.csv");
        toast.success('Feito! Download do arquivo realizado com sucesso! 😎')

        getRelatorioContagemEstoque()
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        dispatch(notIsLoading())
      })
  }
}

function getRelatorioConversoes(payload, showWaiting) {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'relatorios/conversoes' + stringUtils.serialize(payload);
    crudService
      .get(apiEndpoint)
      .then((response) => {
        dispatch(changeRelatorioList(response.data, null))
      })
      .catch((err) => {
        console.log(err);
        return err;
      })
      .finally(() => {
        dispatch(notIsLoading())
      })
  }
}

function getRelatorioLogs(payload, showWaiting) {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'relatorios/logs' + stringUtils.serialize(payload);
    crudService
      .get(apiEndpoint)
      .then((response) => {
        dispatch(changeRelatorioList(response.data, null))
      })
      .catch((err) => {
        console.log(err);
        return err;
      })
      .finally(() => {
        dispatch(notIsLoading())
      })
  }
}

function getRelatorioNivelServico(payload, showWaiting) {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'relatorios/nivelServico' + stringUtils.serialize(payload);
    crudService
      .get(apiEndpoint)
      .then((response) => {
        dispatch(notIsLoading())
        dispatch(changeRelatorioList(response.data, null))
      })
      .catch((err) => {
        console.log(err);
        return err;
      })
  }
}

function getRelatorioPonto(payload, showWaiting) {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'relatorios/pontos' + stringUtils.serialize(payload);
    crudService
      .get(apiEndpoint)
      .then((response) => {
        dispatch(notIsLoading())
        dispatch(changeRelatorioList(response.data, null))
      })
      .catch((err) => {
        console.log(err.response);
        return err.response;
      })
  }
}

function getRelatorioPrecos(payload, showWaiting) {
  return (dispatch) => {
    dispatch(isLoading())

    let apiEndpoint = 'relatorios/precos' + stringUtils.serialize(payload);
    crudService
      .get(apiEndpoint)
      .then((response) => {
        dispatch(changeRelatorioList(response.data.items, response.data.totalRows))
      })
      .catch((err) => {
        console.log(err.response);
        return err.response;
      })
      .finally(() => {
        dispatch(notIsLoading())
      })
  }
}

function getRelatorioPrecosArquivo(filterModel, showWaiting) {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'relatorios/precos/arquivo' + stringUtils.serialize(filterModel);
    crudService
      .get(apiEndpoint, { responseType: 'arraybuffer' })
      .then((response) => {
        var FileSaver = require('file-saver');
        var blob = new Blob([response.data], { type: 'text/csv;charset=utf-16le' });

        FileSaver.saveAs(blob, "relatorio_precos.csv");
        toast.success('Feito! Download do arquivo realizado com sucesso! 😎')

        dispatch(clear())
        getRelatorioPrecos()
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        dispatch(notIsLoading())
      })
  }
}

function getRelatorioDivergenciasFichaTecnica(payload, showWaiting) {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'relatorios/divergenciasFichaTecnica' + stringUtils.serialize(payload);
    crudService
      .get(apiEndpoint)
      .then((response) => {
        dispatch(notIsLoading())
        dispatch(changeRelatorioList(response.data, null))
      })
      .catch((err) => {
        console.log(err.response);
        dispatch(notIsLoading())
        return err.response;
      })
  }
}

function getRelatorioRanking(payload, showWaiting) {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'relatorios/ranking' + stringUtils.serialize(payload);
    crudService
      .get(apiEndpoint)
      .then((response) => {
        dispatch(notIsLoading())
        dispatch(changeRelatorioList(response.data, null))
      })
      .catch((err) => {
        dispatch(notIsLoading())
        console.log(err.response);
        return err.response;
      })
  }
}

function getRelatorioRespostasChecklistsOperacoesImpressoes() {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'relatorios/respostasChecklistsOperacoes/impressoes';
    crudService
      .get(apiEndpoint)
      .then((response) => {
        dispatch(notIsLoading())
        dispatch(changeRelatorioList(response.data, null))
      })
      .catch((err) => {
        dispatch(notIsLoading())
        console.log(err.response);
        return err.response;
      })
  }
}

function getRelatorioTotvsInsumosUnidadesFornecedores(payload, showWaiting) {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'relatorios/totvsInsumosUnidadesFornecedores' + stringUtils.serialize(payload);
    crudService
      .get(apiEndpoint)
      .then((response) => {
        dispatch(notIsLoading())
        dispatch(changeRelatorioList(response.data, null))
      })
      .catch((err) => {
        console.log(err.response);
        return err.response;
      })
  }
}

function getRelatorioTroca(payload, showWaiting) {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'relatorios/trocas'
    crudService
      .post(apiEndpoint, payload)
      .then((response) => {
        dispatch(changeRelatorioList(response.data, response.data.length))
      })
      .catch((err) => {
        console.log(err.response);
        return err.response;
      })
      .finally(() => {
        dispatch(notIsLoading())
      })
  }
}


function getRelatorioVendasInsumos(payload, showWaiting) {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'relatorios/vendasInsumos';
    crudService
      .post(apiEndpoint, payload)
      .then((response) => {
        dispatch(changeRelatorioList(response.data, response.data.lista.totalRows))
      })
      .catch((err) => {
        console.log(err.response);
        return err.response;
      })
      .finally(() => {
        dispatch(notIsLoading())
      })
  }
}

function getRelatorioVendasProdutos(payload, showWaiting) {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'relatorios/vendasProdutos';
    crudService
      .post(apiEndpoint, payload)
      .then((response) => {
        dispatch(changeRelatorioList(response.data, response.data.lista.totalRows))
      })
      .catch((err) => {
        console.log(err.response);
        return err.response;
      })
      .finally(() => {
        dispatch(notIsLoading())
      })
  }
}

function getRelatorioVendasInsumosArquivo(filterModel, showWaiting) {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'relatorios/vendasInsumos/arquivo';
    crudService
      .post(apiEndpoint, filterModel, { responseType: 'arraybuffer' })
      .then((response) => {
        var FileSaver = require('file-saver');
        var blob = new Blob([response.data], { type: 'text/csv;charset=utf-16le' });

        FileSaver.saveAs(blob, "relatorio_vendas_insumos.csv");
        toast.success('Feito! Download do arquivo realizado com sucesso! 😎')

        getRelatorioVendasInsumos()
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        dispatch(notIsLoading())
      })
  }
}

function onChangeProps(props, event) {
  return (dispatch) => {
    if (props == 'relatorio') {
      dispatch(handleOnChangeProps(props, event))
    }
    else {
      dispatch(handleOnChangeProps(props, event.target.value))
    }
  }
}

export function changeRelatorioList(relatorio, totalRows) {
  return {
    type: 'FETCHED_ALL_RELATORIO',
    relatorio: relatorio,
    totalRegistros: totalRows
  }
}

export function clear() {
  return {
    type: 'RELATORIO_CLEAR'
  }
}

export function clearAll() {
  return {
    type: 'RELATORIO_CLEAR_ALL'
  }
}

export function handleOnChangeProps(props, value) {
  return {
    type: 'RELATORIO_HANDLE_ON_CHANGE',
    props: props,
    value: value
  }
}

export function isLoading() {
  return {
    type: 'RELATORIO_ISLOADING'
  }
}

export function notIsLoading() {
  return {
    type: 'RELATORIO_NOTISLOADING'
  }
}
